const zoomOutOverridePlugin = {
    target: 'OpenSeadragonViewer',
    mode: 'add',
    component: ({ viewer }) => {
        if (viewer && viewer.viewport && !viewer.zoomOutUnlocked) {
            try {
                if (viewer.world.getItemCount() > 0) {
                    const trueMinZoom = viewer.viewport.getMinZoom();
                    const customMinZoom = trueMinZoom * 0.1; // Zoom out 10x more than Mirador defines
                    //const customMaxZoom =

                    viewer.viewport.getMinZoom = () => customMinZoom;
                    viewer.viewport.minZoomLevel = customMinZoom;
                    viewer.viewport.applyConstraints();

                    viewer.zoomOutUnlocked = true;
                }
            } catch (e) {
                console.error('[ZoomFix] Failed to apply custom zoom settings', e);
            }
        }

        return null;
    },
};

export  { zoomOutOverridePlugin }

